import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsTerrorismEngagementItemValidator from './validators/items';
import { LegalAssociationsTerrorismEngagementModel } from './types';

const legalAssociationsEngagedTerrorismValidator: ValidateJSModel<LegalAssociationsTerrorismEngagementModel> = {
  HasTerrorismEngagement: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasTerrorismEngagement?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsTerrorismEngagementItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsEngagedTerrorismValidator;
